import { render, staticRenderFns } from "./MenuEmrTemplate.vue?vue&type=template&id=eb84e862&scoped=true"
import script from "./MenuEmrTemplate.vue?vue&type=script&lang=js"
export * from "./MenuEmrTemplate.vue?vue&type=script&lang=js"
import style0 from "./MenuEmrTemplate.vue?vue&type=style&index=0&id=eb84e862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb84e862",
  null
  
)

export default component.exports